import React, { Component } from 'react';
import { connect } from 'react-redux';
import queryString from 'query-string';
import { Alert } from 'reactstrap';

import Spin from '../../../components/ui/Spin';
import { activate, errorSelector } from './account-activation-reducer';

class AccountActivationContainer extends Component {
  constructor(props) {
    super(props);

    this.submit = this.submit.bind(this);
  }

  componentDidMount() {
    this.submit();
  }

  submit() {
    const { location } = this.props;
    const { token, id } = queryString.parse(location.search);
    this.props.handleSubmit({ token, id });
  }

  render() {
    const { error } = this.props;

    if (error) {
      return (
        <Alert
          color="danger"
          style={{ marginBottom: 0 }}
        >
          {error.message}
        </Alert>
      );
    }

    return (
      <div className="text-center">
        <Spin />
        <h4>Activating...</h4>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  error: errorSelector(state),
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  handleSubmit: values => dispatch(activate([
    values,
    () => ownProps.history.push('/'),
  ])),
});

export default connect(mapStateToProps, mapDispatchToProps)(AccountActivationContainer);



// WEBPACK FOOTER //
// ./src/features/Account/AccountActivation/AccountActivationContainer.js